import { Box, ClickAwayListener, Grow, Paper, Popper, Typography, Button } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useUserNotificationContext } from "../../hooks/useUserNotificationContext";
import NotificationItem from "./NotificationItem";

const UserNotificationsPopup = () => {
  const {
    notifications,
    anchorEl,
    isOpen,
    closePopup,
    hasMore,
    loading,
    loadMore
  } = useUserNotificationContext();

  const handleClickAway = (event) => {
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }
    closePopup();
  };

  return (
    <Popper
      open={isOpen}
      anchorEl={anchorEl}
      placement="bottom"
      transition
      disablePortal
      style={{ zIndex: 1300 }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom"
                ? "right top"
                : "right bottom",
          }}
        >
          <Paper
            sx={{
              width: 380,
              maxHeight: 600,
              overflow: "hidden",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <ClickAwayListener onClickAway={handleClickAway}>
              <Box
                sx={{
                  maxHeight: 600,
                  overflowY: "auto",
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    px: 2,
                    py: 1.5,
                    borderBottom: 1,
                    borderColor: "divider",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 600,
                    }}
                  >
                    <FormattedMessage id="notifications"/>
                  </Typography>
                </Box>

                {/* Content */}
                {notifications.length === 0 ? (
                  <Box sx={{ p: 4, textAlign: "center" }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                    >
                      <FormattedMessage id="notifications.noNotifications"/>
                    </Typography>
                  </Box>
                ) : (
                    notifications.map((notification) => (
                      <NotificationItem
                        key={notification.userNotificationId}
                        notification={notification}
                      />
                    ))

                  )}

                {hasMore && (
                  <Box
                    sx={{
                      p: 1,
                      display: "flex",
                      justifyContent: "center",
                      borderTop: 1,
                      borderColor: "divider",
                    }}
                  >
                    <Button
                      onClick={loadMore}
                      disabled={loading}
                    >
                      <FormattedMessage id="notifications.showmore"/>
    </Button>
                  </Box>
                )}
              </Box>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default UserNotificationsPopup;